<template>
  <div>
    <div>
      <el-button
        style="margin-bottom: 10px"
        type="primary"
        icon="el-icon-plus"
        @click="openEditActivityTemplateDialog(true, {})"
        >添加配置</el-button
      >

      <el-button
        style="margin-bottom: 10px; margin-left: 20px"
        type="primary"
        icon="el-icon-document-copy"
        :disabled="this.selectionList.length == 0"
        @click="copyToClipboard()"
        >复制到剪贴板</el-button
      >
      <el-button
        style="margin-bottom: 10px"
        type="primary"
        icon="el-icon-document-add"
        @click="addFromClipboard()"
        >从剪贴板添加</el-button
      >
    </div>

    <el-table
      @select="select"
      @select-all="select"
      :data="list"
      border
      size="small"
      style="width: 1541px"
    >
      <el-table-column type="selection" width="48"> </el-table-column>
      <el-table-column prop="confId" label="配置ID" align="center" width="80">
      </el-table-column>

      <el-table-column
        prop="effectiveAt"
        label="配置生效时间"
        align="center"
        width="135"
      >
        <template slot="header">
          <span>配置生效时间</span>
          <div>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                <MicrofilmComponent
                  :keyword="'activityTemplate-activityConfigEffectiveAt'"
                ></MicrofilmComponent>
              </div>
              <span
                ><i class="el-icon-question" style="font-size: 1.2em"></i
              ></span>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          <span>{{ $util.ms2datetime(scope.row.effectiveAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="expiredAt"
        label="配置失效时间"
        align="center"
        width="135"
      >
        <template slot="header">
          <span>配置失效时间</span>
          <div>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                <MicrofilmComponent
                  :keyword="'activityTemplate-activityConfigExpiredAt'"
                ></MicrofilmComponent>
              </div>
              <span
                ><i class="el-icon-question" style="font-size: 1.2em"></i
              ></span>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          <span>{{ $util.ms2datetime(scope.row.expiredAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="activityTemplateKey"
        label="活动key"
        align="center"
        width="100"
      >
      </el-table-column>

      <el-table-column
        prop="activityType"
        label="活动类型"
        align="center"
        width="100"
      >
        <template slot="header">
          <span> 活动类型</span>
          <div>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                <MicrofilmComponent
                  :keyword="'activityTemplate-activityType'"
                ></MicrofilmComponent>
              </div>
              <span
                ><i class="el-icon-question" style="font-size: 1.2em"></i
              ></span>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          {{ scope.row.activityType }}
        </template>
      </el-table-column>

      <el-table-column prop="name" label="简称" align="center" width="200">
      </el-table-column>

      <el-table-column prop="phase" label="阶段" align="center" width="50">
      </el-table-column>

      <el-table-column
        prop="startAtType"
        label="开始时间类型"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ startAtTypeDesc[scope.row.startAtType] }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="startTime"
        label="活动开始时间"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.startTime }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="keepDays"
        label="持续天数"
        align="center"
        width="80"
      >
      </el-table-column>

      <el-table-column
        prop="isCycle"
        label="循环开启"
        align="center"
        width="50"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.isCycle ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="cycleInterval"
        label="循环间隔"
        align="center"
        width="150"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.isCycle
              ? scope.row.cycleInterval[0] != 0
                ? scope.row.cycleInterval[0] + "天"
                : ""
              : ""
          }}</span>
          <span>{{
            scope.row.isCycle
              ? scope.row.cycleInterval[0] != 0 ||
                scope.row.cycleInterval[1] != 0
                ? scope.row.cycleInterval[1] + "小时"
                : ""
              : ""
          }}</span>
          <span>{{
            scope.row.isCycle
              ? scope.row.cycleInterval[0] != 0 ||
                scope.row.cycleInterval[1] != 0 ||
                scope.row.cycleInterval[2] != 0
                ? scope.row.cycleInterval[2] + "分钟"
                : ""
              : ""
          }}</span>

          <span>{{
            scope.row.isCycle
              ? scope.row.cycleInterval[0] == 0 &&
                scope.row.cycleInterval[1] == 0 &&
                scope.row.cycleInterval[2] == 0
                ? "无缝衔接"
                : ""
              : ""
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="playType"
        label="玩法类型"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{ playTypeDesc[scope.row.playType] }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="isNoNextPlayWhenTimeNotEnough"
        label="放弃开启最后一轮玩法"
        align="center"
        width="160"
      >
        <template slot="header">
          <span> 最后一轮玩法若时间不够就不开启（仅当为循环玩法时有效）</span>
        </template>
        <template slot-scope="scope">
          <span
            v-if="scope.row.isNoNextPlayWhenTimeNotEnough"
            style="color: green"
            >是</span
          >
          <span v-else style="">否</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="playStartTime"
        label="玩法开始时间"
        align="center"
        width="200"
      >
        <template slot="header">
          <span>玩法开始时间</span>
          <div>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">从活动开启后开始计算，单位：分钟</div>
              <span
                ><i class="el-icon-question" style="font-size: 1.2em"></i
              ></span>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          <span
            >{{ scope.row.playStartTime }}（
            {{ Math.floor(scope.row.playStartTime / 60) }}小时{{
              scope.row.playStartTime % 60
            }}分钟）
          </span>
        </template>
      </el-table-column>

      <el-table-column prop="playKeepTime" label="" align="center" width="200">
        <template slot="header">
          <span>玩法持续时长（分钟）</span>
          <div>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                如果玩法持续时长为0，那么玩法默认持续到活动结束
              </div>
              <span
                ><i class="el-icon-question" style="font-size: 1.2em"></i
              ></span>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          <span
            >{{ scope.row.playKeepTime }}（
            {{ Math.floor(scope.row.playKeepTime / 60) }}小时{{
              scope.row.playKeepTime % 60
            }}分钟）
          </span>
        </template>
      </el-table-column>

      <el-table-column prop="isGlobal" label="跨服" align="center" width="60">
        <template slot-scope="scope">
          <span v-if="scope.row.isGlobal" style="color: green">是</span>
          <span v-else style="">否</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <span
            class="link-button"
            @click="openEditActivityTemplateDialog(false, scope.row)"
            >编辑</span
          >
          <span
            class="link-button"
            style="color: red"
            @click="remove(scope.row)"
            >删除</span
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");
import MicrofilmComponent from "@/components/MicrofilmComponent";

export default {
  data() {
    return {
      list: [], // 分区状态列表
      startAtTypeDesc: {},
      playTypeDesc: {},
      selectionList: [],
    };
  },

  async created() {
    await this.loadParam();
    await this.load();
  },

  components: {
    MicrofilmComponent,
  },

  methods: {
    select(selection, row) {
      this.selectionList = selection;
    },
    /**
     * 查询集合
     */
    async load() {
      let resData = (
        await axios.post(
          `${this.$util.getBackendApiBase()}/v1/admin/queryActivityTemplate`,
          {},
          {
            headers: {
              token: this.$bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      // 排序（按分区id倒序排列）
      listInResponse.sort((x, y) => {
        return x.confId - y.confId;
      });

      this.list = listInResponse;
    },

    /**
     * 查询配置
     */
    async loadParam() {
      let resData = (
        await axios.post(
          `${this.$util.getBackendApiBase()}/v1/admin/queryActivityParam`,
          {},
          {
            headers: {
              token: this.$bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let startAtTypeSelects = resData.data.startAtTypeSelects;
      for (let item of startAtTypeSelects) {
        this.startAtTypeDesc[item.value] = item.label;
      }

      let playTypeSelects = resData.data.playTypeSelects;
      for (let item of playTypeSelects) {
        this.playTypeDesc[item.value] = item.label;
      }
    },

    async remove(row) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除配置“${row.confId}”？`);

        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/delActivityTemplate`,
            {
              confId: row.confId,
            },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].confId == row.confId) {
            this.list.splice(i, 1);
            break;
          }
        }
      } catch (e) {
        console.log("err:", e);
      }
    },

    openEditActivityTemplateDialog(isCreate, entry) {
      this.$dialogutil.open("EditActivityTemplateDialog", {
        closedCallback: () => {
          this.load();
        },
        data: { isCreate: isCreate, entry: entry },
      });
    },

    /**
     * 复制到剪贴板
     */
    async copyToClipboard() {
      if (this.selectionList.length == 0) {
        this.$message({
          message: "未选中任何可复制内容",
          type: "warning",
        });
      }
      try {
        await navigator.clipboard.writeText(
          JSON.stringify({ copyActivityTemplates: this.selectionList })
        );
        this.$message({
          message: "复制成功",
          type: "success",
        });
      } catch (err) {
        this.$message.error("复制失败： " + JSON.stringify(err));
      }
    },

    async addFromClipboard() {
      let addFunc = async (val) => {
        try {
          // 弹确认框
          await this.$confirm(`确认新增配置？`);

          let resData = (
            await axios.post(
              `${this.$util.getBackendApiBase()}/v1/admin/addActivityTemplate`,
              { entry: val },
              {
                headers: {
                  token: this.$bizutil.getLoginUserToken(),
                },
              }
            )
          ).data;
          if (resData.code > 0) {
            this.$message.error(resData.message);
            return;
          }

          // 弹确认框
          await this.$confirm(`添加成功`);

          // 关闭当前对话框
          this.onClose();
        } catch (e) {}
      };
      let result = await navigator.permissions.query({
        name: "clipboard-read",
      });

      if (result.state === "granted" || result.state === "prompt") {
        // 可以使用权限
        // 进行clipboard的操作
        let text = await navigator.clipboard.readText();

        let obj = JSON.parse(text).copyActivityTemplates;
        if (obj) {
          for (let i = 0; i < obj.length; i++) {
            let item = obj[i];
            await addFunc(item);
          }

          this.selectionList = [];
          this.load();
        }
      } else if (result.state === "denied") {
        alert("已禁止访问粘贴板，请手动开启权限");
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.zone-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.zone-status-tag-maintained {
  background-color: lightgray;
  border-color: lightgray;
}

.zone-status-tag-idle {
  background-color: chartreuse;
  border-color: chartreuse;
}

.zone-status-tag-full {
  background-color: rgb(243, 159, 159);
  border-color: red;
}

.el-icon-round {
  border-radius: 50%;
  width: 10px;
  height: 10px;
}

.link-button {
  padding-left: 10px;
  color: rgb(37, 148, 240);
  cursor: pointer;
}

/deep/ .el-table__row td {
  padding: 3px 0;
}

/deep/ .el-table .cell {
  line-height: 18px;
}
</style>